import type { SVGProps } from 'react';
export const IconPointsPochta = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_17014_40727)">
      <path
        d="M18 0.5C27.665 0.5 35.5 8.33502 35.5 18C35.5 27.665 27.665 35.5 18 35.5C8.33502 35.5 0.5 27.665 0.5 18C0.5 8.33502 8.33502 0.5 18 0.5Z"
        fill="#1928DC"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip1_17014_40727)">
        <mask
          id="mask0_17014_40727"
          style={{
            maskType: 'luminance'
          }}
          maskUnits="userSpaceOnUse"
          x={6}
          y={11}
          width={24}
          height={15}
        >
          <path
            d="M29.1569 11.6016H6.83984V25.2024H29.1569V11.6016Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_17014_40727)">
          <path
            d="M10.5985 11.7026V17.7955H9.58305V12.5794H7.85533V17.7955H6.83984V11.7026H10.5985Z"
            fill="white"
          />
          <path
            d="M12.434 17.5547C12.1298 17.2753 11.9086 16.9174 11.7947 16.5204C11.6279 15.9633 11.5486 15.3836 11.5596 14.8021C11.5488 14.2044 11.6281 13.6085 11.7947 13.0344C11.9065 12.6243 12.1275 12.2523 12.434 11.9578C12.7021 11.7279 13.0435 11.6016 13.3966 11.6016C13.7497 11.6016 14.0912 11.7279 14.3592 11.9578C14.6674 12.2496 14.888 12.6217 14.9963 13.0321C15.1631 13.6069 15.2423 14.2036 15.2313 14.8021C15.2422 15.3844 15.1629 15.9648 14.9963 16.5228C14.8852 16.92 14.6654 17.2782 14.3616 17.5571C14.0882 17.7775 13.7477 17.8976 13.3966 17.8976C13.0455 17.8976 12.705 17.7775 12.4317 17.5571L12.434 17.5547ZM12.6832 16.0127C12.7229 16.2784 12.8209 16.532 12.97 16.7555C13.017 16.8259 13.0801 16.8839 13.1541 16.9248C13.2281 16.9657 13.3109 16.9883 13.3955 16.9906C13.647 16.9906 13.8444 16.8072 13.9902 16.4405C14.1588 15.9091 14.232 15.352 14.2064 14.7951C14.2129 14.3714 14.1799 13.948 14.1077 13.5304C14.0698 13.2559 13.9727 12.9928 13.8233 12.7594C13.7813 12.6829 13.7196 12.6191 13.6445 12.5747C13.5695 12.5302 13.4839 12.5068 13.3966 12.5068C13.3094 12.5068 13.2238 12.5302 13.1487 12.5747C13.0737 12.6191 13.0119 12.6829 12.97 12.7594C12.8223 12.993 12.7247 13.2548 12.6832 13.5281C12.6102 13.9448 12.5764 14.3674 12.5821 14.7904C12.5757 15.2001 12.6096 15.6095 12.6832 16.0127Z"
            fill="white"
          />
          <path
            d="M18.5843 11.7021V14.0387H18.046C17.8509 14.0494 17.656 14.014 17.4772 13.9353C17.336 13.8603 17.2279 13.7355 17.174 13.585C17.1021 13.3757 17.0695 13.155 17.0776 12.9339V11.7021H16.0621V12.9292C16.0326 13.4585 16.1907 13.9812 16.5087 14.4054C16.6757 14.5909 16.8827 14.7359 17.114 14.8296C17.3453 14.9233 17.5949 14.9631 17.8439 14.946H18.5843V17.795H19.5998V11.7021H18.5843Z"
            fill="white"
          />
          <path
            d="M24.0553 12.5794H22.8635V17.7955H21.848V12.5794H20.6562V11.7026H24.0553V12.5794Z"
            fill="white"
          />
          <path
            d="M26.1003 11.7017H26.9136C27.2487 11.6836 27.5818 11.7654 27.8703 11.9368C28.1222 12.1051 28.3179 12.3449 28.4322 12.6255C28.572 12.9736 28.6598 13.3402 28.6931 13.7138L29.1632 17.7828H28.1478L27.8187 14.9409H26.0955V17.7946H25.0801V11.7017H26.1003ZM26.1003 14.0758H27.7223L27.68 13.7256C27.6612 13.5005 27.6145 13.2787 27.5412 13.0651C27.4898 12.9213 27.389 12.8005 27.2567 12.7242C27.0862 12.6425 26.8978 12.6053 26.709 12.6161H26.1003V14.0758Z"
            fill="white"
          />
          <path
            d="M7.95875 19.0089C8.29733 19 8.6315 19.0872 8.92252 19.2605C9.20785 19.4421 9.43029 19.7072 9.55955 20.0197C9.72467 20.418 9.80474 20.8463 9.79461 21.2773C9.80507 21.685 9.73228 22.0905 9.58071 22.4691C9.46841 22.7599 9.28687 23.0189 9.05181 23.2237C8.89287 23.3734 8.68675 23.4632 8.46884 23.4775C8.35598 23.4854 8.24275 23.4685 8.13715 23.4279C8.03155 23.3872 7.93615 23.324 7.85768 23.2425V25.1018H6.83984V19.0089H7.95875ZM7.91409 22.1635C7.93913 22.2724 7.99083 22.3734 8.06453 22.4573C8.08854 22.4869 8.11857 22.511 8.15262 22.528C8.18667 22.545 8.22395 22.5546 8.26199 22.5561C8.35121 22.5511 8.43523 22.5125 8.49705 22.4479C8.59199 22.3493 8.65998 22.2278 8.6945 22.0953C8.75161 21.8928 8.77777 21.6828 8.77208 21.4724C8.77208 20.9036 8.7039 20.5016 8.56287 20.2665C8.50513 20.1579 8.4182 20.0676 8.31188 20.0057C8.20556 19.9438 8.08407 19.9128 7.9611 19.9163H7.85768V21.6934C7.85454 21.8519 7.87353 22.0102 7.91409 22.1635Z"
            fill="white"
          />
          <path
            d="M10.9165 24.858C10.6109 24.5788 10.3895 24.2198 10.2771 23.8214C10.1102 23.2643 10.0309 22.6846 10.042 22.1031C10.0313 21.5062 10.1105 20.911 10.2771 20.3377C10.388 19.9279 10.6092 19.5564 10.9165 19.2635C11.1845 19.0336 11.526 18.9072 11.8791 18.9072C12.2322 18.9072 12.5736 19.0336 12.8417 19.2635C13.1485 19.5554 13.3689 19.9263 13.4787 20.3354C13.6453 20.9103 13.7246 21.507 13.7138 22.1054C13.7288 22.6871 13.6535 23.2676 13.4905 23.8261C13.38 24.2235 13.1601 24.5819 12.8558 24.8604C12.5832 25.0824 12.2424 25.2036 11.8908 25.2036C11.5393 25.2036 11.1985 25.0824 10.9259 24.8604L10.9165 24.858ZM11.168 23.3184C11.2092 23.5775 11.3063 23.8245 11.4524 24.0424C11.4989 24.1121 11.5613 24.1697 11.6345 24.2106C11.7076 24.2515 11.7895 24.2744 11.8732 24.2774C12.1239 24.2774 12.3214 24.0941 12.4656 23.7274C12.6365 23.1964 12.7106 22.6391 12.6842 22.0819C12.6906 21.6582 12.6575 21.2348 12.5854 20.8173C12.5464 20.5445 12.4495 20.2831 12.301 20.051C12.2591 19.9745 12.1973 19.9107 12.1223 19.8662C12.0472 19.8218 11.9616 19.7983 11.8744 19.7983C11.7871 19.7983 11.7015 19.8218 11.6265 19.8662C11.5514 19.9107 11.4897 19.9745 11.4477 20.051C11.2998 20.2915 11.2044 20.5607 11.168 20.8408C11.0952 21.2575 11.0614 21.6801 11.0669 22.1031C11.061 22.5105 11.0949 22.9175 11.168 23.3184Z"
            fill="white"
          />
          <path
            d="M14.4063 20.3843C14.6542 19.9253 15.0443 19.559 15.5182 19.3407C16.0729 19.0998 16.6744 18.9858 17.2788 19.0069V19.9213C16.5548 19.9213 16.0024 20.1023 15.6192 20.469C15.2361 20.8357 15.0433 21.3787 15.0433 22.1144C15.0433 22.8502 15.2337 23.3368 15.6169 23.68C16 24.0232 16.5571 24.1971 17.2788 24.1971V25.0998C16.2398 25.0998 15.4382 24.849 14.8741 24.3475C14.3099 23.8461 14.0278 23.0978 14.0278 22.1027C14.0055 21.507 14.1358 20.9155 14.4063 20.3843Z"
            fill="white"
          />
          <path
            d="M17.8272 20.3861C18.0752 19.9263 18.4664 19.5599 18.9414 19.3424C19.4924 19.0994 20.0907 18.9821 20.6927 18.9992V19.9136C19.971 19.9136 19.4186 20.0946 19.0331 20.4613C18.6476 20.828 18.4572 21.3804 18.4572 22.1044C18.4572 22.8284 18.6476 23.3267 19.0307 23.6699C19.4139 24.0131 19.971 24.1871 20.6903 24.1871V25.1015C19.6513 25.1015 18.8497 24.8507 18.2856 24.3493C17.7214 23.8478 17.4394 23.0995 17.4394 22.1044C17.4199 21.5079 17.5534 20.9164 17.8272 20.3861Z"
            fill="white"
          />
          <path
            d="M22.1839 19.0084V21.1828L23.9092 19.7277L24.9247 18.8721V25.1013H23.9092V20.9547L22.1839 22.4098V25.1013H21.166V19.0084H22.1839Z"
            fill="white"
          />
          <path
            d="M26.418 19.0076V21.182L28.1433 19.7269L29.154 18.876V25.1005H28.1386V20.954L26.4132 22.409V25.1005H25.4023V19.0076H26.418Z"
            fill="white"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_17014_40727">
        <rect
          width={36}
          height={36}
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_17014_40727">
        <rect
          width={22.5}
          height={13.7195}
          fill="white"
          transform="translate(6.75 11.5425)"
        />
      </clipPath>
    </defs>
  </svg>
);
